<template>
<div v-if="asset != null">
  <v-row v-if="!$vuetify.breakpoint.smAndDown" no-gutters="" align="start" justify="start" style="position:relative">
    <v-col
    cols="5"
    v-if="asset.resources != null && asset.resources.length"
    ref="sideColumn"
    >
      <v-carousel
        v-model="carouselModel"
          cycle
          height="690px"
          :show-arrows="false"
          hide-delimiters=""
          :touchless="true"
          vertical
        >
          <v-carousel-item
            v-for="(resource, i) in imageResources"
            :key="i"
            style="position:relative"
          >
          <v-card width="100%" height="100%" tile class="d-flex" flat>
             <v-img style="position:absolute;" :src="resource.url" width="100%" height="100%" :position="GetPositionForImage(resource)">
            </v-img>
          </v-card>
          </v-carousel-item>
        </v-carousel>
      Test Overview
    </v-col>
    <v-col cols="7">
      <div style="padding:60px;overflow-y:auto;max-height:690px;">
      <v-card flat color="transparent" class="pb-4" >
        <v-card class="mb-4" width="220px" height="140px" style="position:relative" flat color="transparent" v-if="showHeaderImage">
           <v-img
              :src="headerImage.url"
              height="140px"
              contain
              style="position:absolute;"
              />
        </v-card>
         <div v-if="typeData.useIcons" style="margin-bottom:-10px">
            <v-img :src="GetIconForResource(asset.resources[carouselModel])" height="80px" width="40px" contain/>
          </div>
         <h1 style="color:white;font-family:waHeadline;font-size:42px" class="mt-0 pt-0">
          {{asset.name}}
        </h1>
        <br/>
        <p style="color:white;font-family:waRegular;white-space: pre-line;font-size:20px;">
          <span v-html="validContent.html" style="color:white">
          </span>
        </p>
      </v-card>
      </div>
    </v-col>
  </v-row>
  <v-row v-if="$vuetify.breakpoint.smOnly" no-gutters="" align="start" justify="center" style="position:relative" class="pa-4">
    <v-col cols="4">
       <h1 style="color:white;font-family:waHeadline;font-size:28px" class="mt-0 pt-0 pr-2">
          {{asset.name}}
        </h1>
        <v-card class="" width="100%" height="150px" style="position:relative" flat color="transparent" v-if="showHeaderImage">
           <v-img
              :src="headerImage.url"
              width="100%"
              height="150px"
              contain
              style="position:relative;"
              />
        </v-card>
        <div v-else-if="keyFactContent != null" class="pt-4">
          <div v-for="(fact,index) in keyFactContent.facts" :key="index" class="mb-4">
            <p class="pb-0 mb-0" style="color:white;font-family:waRegular;font-size:18px">
              <i>{{fact.key}}</i>
            </p>
            <span  style="color:white;font-family:waRegular;font-size:18px;text-decoration: underline;">
              {{fact.value}}
            </span>
          </div>
        </div>
    </v-col>
    <v-col cols="8">
      <v-carousel
        v-model="carouselModel"
          cycle
          height="250px"
          :show-arrows="false"
          hide-delimiters=""
          :touchless="true"
          vertical
        >
          <v-carousel-item
            v-for="(resource, i) in imageResources"
            :key="i"
            style="position:relative"
          >
          <v-card width="100%" height="250px" tile class="d-flex" flat>
             <v-img style="position:absolute;" :src="resource.url" height="100%" :position="GetPositionForImage(resource)">
            </v-img>
          </v-card>
          </v-carousel-item>
        </v-carousel>
    </v-col>
    <v-col cols="12" class="pt-4">
      <p style="color:white;font-family:waRegular;white-space: pre-line;font-size:18px;">
          <span v-html="validContent.html" style="color:white">
          </span>
        </p>
    </v-col>
  </v-row>
  <v-row v-if="$vuetify.breakpoint.xsOnly" no-gutters="" align="start" justify="center" style="position:relative" class="pa-4">
    <v-col :cols="(showHeaderImage) ? 8 : 12">
       <h1 style="color:white;font-family:waHeadline;font-size:24px" class="mt-0 pt-0 pr-2 pb-2">
          {{asset.name}}
        </h1>
       
    </v-col>
    <v-col cols="4" v-if="showHeaderImage">
       <v-card class="" width="100%" height="100px" style="position:relative" flat color="transparent" v-if="showHeaderImage">
           <v-img
              :src="headerImage.url"
              width="100%"
              height="100px"
              contain
              style="position:relative;"
              />
        </v-card>
    </v-col>
    <v-col cols="12">
      <v-carousel
        v-model="carouselModel"
          cycle
          height="250px"
          :show-arrows="false"
          hide-delimiters=""
          :touchless="true"
          vertical
        >
          <v-carousel-item
            v-for="(resource, i) in imageResources"
            :key="i"
            style="position:relative"
          >
          <v-card width="100%" height="250px" tile class="d-flex" flat>
             <v-img style="position:absolute;" :src="resource.url" height="100%" :position="GetPositionForImage(resource)">
            </v-img>
          </v-card>
          </v-carousel-item>
        </v-carousel>
    </v-col>
    <v-col cols="12" class="pt-4">
      <p style="color:white;font-family:waRegular;white-space: pre-line;font-size:18px;">
          <span v-html="validContent.html" style="color:white">
          </span>
        </p>
    </v-col>
  </v-row>
</div>
</template>

<script>

import {mapState} from 'vuex'
  export default {
    name: 'ContentOverview',
    components: {
    },
    props: {

      typeData : null,
      content : null,
      icons : Array,
      asset : null

    },
    computed: {

      ...mapState("sessionState", [
        "currentLanguage",
      ]),

      keyFactContent()
      {
        var contentWithKeyFrames = this.asset.contents.filter(content => content.type ==  2);

        if(contentWithKeyFrames.length > 0)
        {
          return contentWithKeyFrames[0];
        }
        else
        {
          return null;
        }
      },

      validContent()
      {
        var foundLocale = this.content.filter(c => c.title == this.currentLanguage);

        if(foundLocale.length > 0)
        {
          return foundLocale[0];
        }
        else
        {
          return this.content[0];
        }
      },
      headerImage()
      {
        if(this.asset.resources == null)
          return;

        if(this.typeData == null)
        return null;

        var imageResourcesWithTag = this.asset.resources.filter(resource => resource.type == 0 && resource.tags.includes(this.typeData.headerImageTag));

        if(imageResourcesWithTag.length == 0)
        return null;
        else
        return imageResourcesWithTag[0];
      },
      showHeaderImage()
      {
        if(this.typeData == null)
          return false;
        else if(this.typeData.headerImageTag == null)
          return false;
        else if(this.headerImage == null)
          return false;
        else
          return true;
      },
      imageResources()
      {
        var overviewImages = this.asset.resources.filter(resource => resource.tags.includes("Overview"));

        if(overviewImages.length > 0)
        {
          return overviewImages;
        }
        var imageResources = this.asset.resources.filter(resource => resource.type == 0 && !resource.tags.includes("NoGallery"));
        var headerResource = this.headerImage;
        if(headerResource != null)
        {
          for (let i = 0; i < imageResources.length; i++) 
          {
            if(headerResource.id == imageResources[i].id)
            {
              imageResources.splice(i,1);
              break;
            }
          }
        }
        return imageResources;
      }
    },

    mounted () {

    },
    data: () => ({

      carouselModel : 0

    }),
    methods: {

      GetPositionForImage(imgResource)
      {
        if(imgResource.tags.some(t => t.includes("crop-left")))
        {
          return "left";
        }
        else if (imgResource.tags.some(t => t.includes("crop-top")))
        {
          return "top";
        }
        else if (imgResource.tags.some(t => t.includes("crop-right")))
        {
          return "right";
        }
        else if (imgResource.tags.some(t => t.includes("crop-bottom")))
        {
          return "bottom";
        }
        else if (imgResource.tags.some(t => t.includes("crop-center")))
        {
          return "center";
        }
        else
        {
          return "top";
        }
      }



    },
    watch: {
      
    }
  }
</script>
